export function shareableLinkRowId(referralLinkId: number) {
  return `referral-link-row-${referralLinkId}`
}
